import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, TitleStrategy }  from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  provideAnimationsAsync,
}                                  from '@angular/platform-browser/animations/async';
import {
  MsalGuard,
  MsalInterceptor,
  MsalBroadcastService,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
}                                  from '@azure/msal-angular';
import { IPublicClientApplication } from '@azure/msal-browser';
import { HTTP_INTERCEPTORS }        from '@angular/common/http';

import { routes }                  from './app.routes';
import {
  msalGuardConfig,
  msalInterceptorConfig,
}                                  from './auth/auth-config';
import { AppTitleStrategy }        from './core/services/title.strategy';

/**
 * Build the Angular ApplicationConfig, receiving an already-initialized
 * PublicClientApplication from main.ts.
 *
 * MSAL 3.x requires initialize() to be called before Angular bootstraps.
 * The instance is created and awaited in main.ts, then passed in here so
 * that MSAL_INSTANCE provides the ready-to-use object.
 */
export function createAppConfig(msalInstance: IPublicClientApplication): ApplicationConfig {
  return {
    providers: [
      // ── Core Angular providers ──────────────────────────────────────────
      provideZoneChangeDetection({ eventCoalescing: true }),
      provideRouter(routes),
      provideHttpClient(withInterceptorsFromDi()),
      provideAnimationsAsync(),

      // ── MSAL instance (pre-initialized in main.ts) ──────────────────────
      {
        provide: MSAL_INSTANCE,
        useValue: msalInstance,
      },

      // ── MSAL guard config ────────────────────────────────────────────────
      {
        provide: MSAL_GUARD_CONFIG,
        useValue: msalGuardConfig,
      },

      // ── MSAL interceptor config ──────────────────────────────────────────
      {
        provide: MSAL_INTERCEPTOR_CONFIG,
        useValue: msalInterceptorConfig,
      },

      // ── MSAL HTTP interceptor — attaches Bearer token to API requests ────
      {
        provide: HTTP_INTERCEPTORS,
        useClass: MsalInterceptor,
        multi: true,
      },

      // ── MSAL services ────────────────────────────────────────────────────
      MsalGuard,
      MsalService,
      MsalBroadcastService,

      // ── Custom page title strategy ────────────────────────────────────────
      { provide: TitleStrategy, useClass: AppTitleStrategy },
    ],
  };
}

